import { createSlice } from '@reduxjs/toolkit';
import { UserReducer } from '../../reducers/UserReducer';
import { IUser } from '../../../auth/interfaces/IUser';
import { LoggedUserType } from '../../../auth/enums/LoggedUserType';

const initialState: IUser = {
	email: null,
	token: null,
	document_type: null,
	logged_type: LoggedUserType.IS_GUEST,
};

export const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: UserReducer,
});

export const {
	setDocument,
	setUserType,
	setUser,
	setToken,
	setUserDestination,
	setPendingIpaf,
	setInProgressIpaf,
	setIsRenewingUser,
	setUserFormId,
	toggleIsFirstIpaf,
	setHasCyber,
	setUploadInProcess,
	setLastIpafTag
} = userSlice.actions;

export default userSlice.reducer;
